<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>اختصاص دادن شماره به کاربر</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.number.val" :description="form.number.inv" label="شماره" />
                                </CCol>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>درگاه</label>
                                    <model-select :options="gateways" v-model="form.sms_gateway_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.sms_gateway_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>تعرفه</label>
                                    <model-select :options="fees" v-model="form.operators_fee_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.operators_fee_id.inv}}</small>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: true, label:'فعال'},
                                            {value: false, label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.url_check.val"
                                        :description="form.url_check.inv"
                                        label="URL check"
                                        :options="[
                                            {value: true, label:'فعال'},
                                            {value: false, label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.url_check.val=$event.target.value"
                                    />
                                </CCol> 
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_confirme.val"
                                        :description="form.is_confirme.inv"
                                        label="is confirme"
                                        :options="[
                                            {value: true, label:'فعال'},
                                            {value: false, label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_confirme.val=$event.target.value"
                                    />
                                </CCol> 
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.delivery_base.val"
                                        :description="form.delivery_base.inv"
                                        label="delivery base"
                                        :options="[
                                            {value: true, label:'فعال'},
                                            {value: false, label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.delivery_base.val=$event.target.value"
                                    />
                                </CCol> 
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.check_blacklist.val"
                                        :description="form.check_blacklist.inv"
                                        label="check blacklist"
                                        :options="[
                                            {value: true, label:'فعال'},
                                            {value: false, label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.check_blacklist.val=$event.target.value"
                                    />
                                </CCol> 
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_service.val"
                                        :description="form.is_service.inv"
                                        label="is service"
                                        :options="[
                                            {value: true, label:'فعال'},
                                            {value: false, label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_service.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_global.val"
                                        :description="form.is_global.inv"
                                        label="is global"
                                        :options="[
                                            {value: true, label:'فعال'},
                                            {value: false, label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_global.val=$event.target.value"
                                    />
                                </CCol> 
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.can_receive.val"
                                        :description="form.can_receive.inv"
                                        label="can receive"
                                        :options="[
                                            {value: true, label:'فعال'},
                                            {value: false, label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.can_receive.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>      
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="submit()" color="primary"> ارسال</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                user_id: { val: '', inv: this.$store.state.user_id, v: { req: true, max: 8 } },
                number: { val: '', inv: '', v: { req: true, max: 1024 } },
                sms_gateway_id: { val: '', inv: '', v: { req: true, max: 4 } },
                is_active: { val: '', inv: '', v: { req: true, max: 8 } },
                operators_fee_id: { val: '', inv: '', v: { req: true, max: 8 } },
                url_check: { val: '', inv: '', v: { req: true, max: 8 } },
                is_confirme: { val: '', inv: '', v: { req: true, max: 8 } },
                delivery_base: { val: '', inv: '', v: { req: true, max: 8 } },
                check_blacklist: { val: '', inv: '', v: { req: true, max: 8 } },
                is_service: { val: '', inv: '', v: { req: true, max: 8 } },
                is_global: { val: '', inv: '', v: { req: true, max: 8 } },
                can_receive: { val: '', inv: '', v: { req: true, max: 8 } },
            },
            disable: false,
            users: [],
            gateways: [],
            fees: [],
            user_numbers: [],
            active_page: 1,
        }
    },
    watch: {
        'form.sms_gateway_id.val':{
            handler(){
                if(this.form.user_id.val != ''){
                    this.fill_fee();
                }
            }
        }
    },
    mounted(){
        this.get_users();
        this.get_gateways();
        this.get_fees();
        this.get_number();
    },
    methods: {
        get_number(){
           this.axios.get('/user_nums/'
                +'?id=' + this.$route.params.id)
                .then(res => {
                    for(const key in res.data[0]){
                        for(const k in this.form){
                            if(key == k){
                                this.form[k].val = res.data[0][key];
                            }
                        }
                    }
                }) 
        },
        get_fees(){
            this.axios.get('operators_fee/')
            .then(res => {
                res.data.map(val => {
                    this.fees.push({value: val.id, text: val.name});
                });
            })
        },
        get_gateways(){
            this.axios.get('sms_gateways/')
            .then(res => {
                res.data.map(val => {
                    this.gateways.push({value: val.id, text: val.name});
                });
            })
        },
        get_users(){
            this.axios.get('users/?type=add_user_nums')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                this.axios.post('user_nums/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'ارسال با موفقیت انجام شد.'
                        });
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })  
            }
        },
        fill_fee(){
            this.axios.get('user_nums/'
                +'?user_id=' + this.form.user_id.val
                + '&sms_gateway_id=' + this.form.sms_gateway_id.val)
                .then(res => {
                    this.form.operators_fee_id.val = res.data[0].operators_fee_id;
                })
        }
    },
    beforeCreate() {
        if (this.$store.state.perms.can_add_all_users_nums == false
            && this.$store.state.perms.can_add_same_group_users_nums == false
            && this.$store.state.perms.can_add_user_nums == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
